import { useRef } from "react";
import { YStack } from "@medbillai/ui";
import type { FlowTimelineTransitionGroup } from "./timelineTransition";
export function FlowTimelineGroupContents({
  group,
  activeStateKey
}: {
  group: FlowTimelineTransitionGroup;
  activeStateKey: string;
}) {
  const activeVisit = group.visits.find(visit => visit.stateKey === activeStateKey);
  const lastActiveStateKeyRef = useRef(activeVisit?.stateKey);
  if (activeVisit) {
    lastActiveStateKeyRef.current = activeVisit.stateKey;
  }
  const visibleStateKey = lastActiveStateKeyRef.current ?? group.visits[0]?.stateKey;
  return group.visits.map(visit => {
    const visible = visit.stateKey === visibleStateKey;
    return <YStack key={visit.stateKey} flex={1} height="100%" display={visible ? "flex" : "none"} pointerEvents={visible ? "auto" : "none"} accessibilityElementsHidden={!visible} importantForAccessibility={visible ? "auto" : "no-hide-descendants"}>
        {visit.content}
      </YStack>;
  });
}